import { createContext, useContext } from 'react';

/**
 * True when rendered inside a HubShell tab body. PageLayout uses this to skip
 * duplicate chrome (header, padding shell) that would stack and cause scroll jank.
 */
export const HubShellContext = createContext(false);

export function useHubShellEmbedded(): boolean {
  return useContext(HubShellContext);
}
